var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visibility",
    clipPath: "url(#clip0_2140_15115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.00065 4.30534C9.21148 4.30534 11.1832 5.54784 12.1457 7.51367C11.1832 9.47951 9.21148 10.722 7.00065 10.722C4.78982 10.722 2.81815 9.47951 1.85565 7.51367C2.81815 5.54784 4.78982 4.30534 7.00065 4.30534ZM7.00065 3.13867C4.08398 3.13867 1.59315 4.95284 0.583984 7.51367C1.59315 10.0745 4.08398 11.8887 7.00065 11.8887C9.91732 11.8887 12.4082 10.0745 13.4173 7.51367C12.4082 4.95284 9.91732 3.13867 7.00065 3.13867ZM7.00065 6.05534C7.80565 6.05534 8.45898 6.70867 8.45898 7.51367C8.45898 8.31867 7.80565 8.972 7.00065 8.972C6.19565 8.972 5.54232 8.31867 5.54232 7.51367C5.54232 6.70867 6.19565 6.05534 7.00065 6.05534ZM7.00065 4.88867C5.55398 4.88867 4.37565 6.06701 4.37565 7.51367C4.37565 8.96034 5.55398 10.1387 7.00065 10.1387C8.44732 10.1387 9.62565 8.96034 9.62565 7.51367C9.62565 6.06701 8.44732 4.88867 7.00065 4.88867Z",
    fill: "#6B717A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2140_15115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.805176)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/visibility.a4a1a90a409944e3166fd04e04dd3965.svg";
export { ForwardRef as ReactComponent };